const MA = {
  ibanLength: 28,
  countryConfig: {
    accountNumber: {
      visible: false,
      required: false,
    },
    accountHolderDocNumber: {
      label: "bankDetails.idNumber",
      required: true,
    },
    IBAN: {
      visible: true,
      label: "bankDetails.IBAN",
      required: true,
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
    },
    bankName: {
      label: "bankDetails.bankName",
      visible: true,
      required: true,
    },
    bankAddress: {
      visible: false,
    },
  },
};
export { MA };
